<template>
  <div id="zh-input" >
      <input type="text" ref="input"
             v-bind:value="value"
             v-on:input="$emit('input', $event.target.value)"
              placeholder="">
  </div>
</template>
<script>
  export default {
    name:'zh-input',
    props:{
      value:''
    },
    data(){
      return{
        currentValue:this.value,
      }
    },
    watch:{
    },
    methods:{

      handleInput(){

      },
    },
    computed:{
      newValue() {
        return this.value
      }
    }
  }
</script>
<style lang="less" scoped>
  #zh-input{

  }
</style>



// WEBPACK FOOTER //
// ui/input/src/zhInput.vue